/**
 * Tailwind CSS breakpoint values for use in JavaScript.
 * Must stay in sync with Tailwind's default theme breakpoints.
 */
export const SM_BREAKPOINT = 640;
export const MD_BREAKPOINT = 768;
export const LG_BREAKPOINT = 1024;
export const XL_BREAKPOINT = 1280;
